import { clientPostWrapper } from "../api/Api";
import { SHARE_LINK_INTEGRATION } from "../common/constants/routes";

export const sendShareLink = (link) => {
    return clientPostWrapper(SHARE_LINK_INTEGRATION, { link });
}
